export const CART_PRODUCTS_QUERY_KEY = 'cart-products-query-key';
